export const socialsData = {
  github: "https://github.com/ayaanhaider-dev/",
  linkedIn: "https://www.linkedin.com/in/ayaanhaider-dev/",
  fiverr: "https://www.fiverr.com/itsayaanhaider",
  medium: "https://medium.com/@ayaanhaider.dev",
  stackOverflow: "https://stackoverflow.com/users/",
};
